import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { ArrowPathIcon } from '@heroicons/react/24/solid';
import { AddService } from '../../../../redux/reducer/servicesReducer';

const AddServiceForm = ({ onClose }) => {
  const dispatch = useDispatch();

  
  const [isLoading, setIsLoading] = useState(false);

  const [nameEn, setNameEn] = useState("");
  const [nameAr, setNameAr] = useState("");
  const [descEn, setDescEn] = useState("");
  const [descAr, setDescAr] = useState("");
  const [image, setImage] = useState(null);

 


  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 bg-opacity-30bg-black">
      <div className="bg-white p-6 rounded-xl w-[90%] max-w-lg shadow-xl space-y-4">
        <h2 className="text-xl font-bold text-black">Add New Service</h2>

        <div className='flex gap-2'>
            <input
              type="text"
              placeholder="Name EN"
              className="w-full px-2 py-2 text-xs text-black bg-gray-100 border rounded-lg"
              value={nameEn}
              onChange={(e) => setNameEn(e.target.value)}
              required
            />
            <input
              type="text"
              placeholder="Name AR"
              className="w-full px-2 py-2 text-xs text-black bg-gray-100 border rounded-lg"
              value={nameAr}
              onChange={(e) => setNameAr(e.target.value)}
              required
            />
          </div>
          

          <div className='flex gap-2'>
            <textarea
              type="text"
              placeholder="Short Description EN"
              className="w-full px-2 py-2 text-xs text-black bg-gray-100 border rounded-lg"
              value={descEn}
              onChange={(e) => setDescEn(e.target.value)}
              required
            />
            <textarea
              type="text"
              placeholder="Short Description AR"
              className="w-full px-2 py-2 text-xs text-black bg-gray-100 border rounded-lg"
              value={descAr}
              onChange={(e) => setDescAr(e.target.value)}
              required
            />
          </div>
          

          <div className='flex gap-2'>
            <input
              type="file"
              className="w-full px-2 py-2 text-xs text-black bg-gray-100 border rounded-lg"
              onChange={(e) => setImage(e.target.files[0])}
              required
            />
          </div>



        <div className="flex justify-end gap-4">
        {isLoading ? null : (<button
            className="px-4 py-2 text-sm text-white duration-300 bg-gray-600 rounded-lg hover:bg-gray-800"
            onClick={onClose}
          >
            Cancel
          </button>)}
          {isLoading ? (
              <ArrowPathIcon className="w-10 h-10 p-2 text-white rounded-full animate-spin bg-custom-yellow" />
            ) : (
              <button className="px-4 py-2 text-sm text-black duration-300 rounded-lg hover:text-white bg-custom-yellow hover:bg-yellow-600"
              onClick={() =>{
 
              setIsLoading(true); 
 
              dispatch(AddService({
                data: {
                  nameEn,
                  nameAr,
                  descEn,
                  descAr,
                  image
                },
               })
             )
                 .unwrap()
                 .then(() => {
                   alert("The Service has been added successfully.");
                 })
                 .catch((error) => {
                   alert("Failed to add the Service: " + error);
                 })
                 .finally(() => {
                   setIsLoading(false); 
                   onClose()
                 });
             }}
           >
               Submit
           </button>
            )}
          
        </div>
      </div>
    </div>
  );
};

export default AddServiceForm;
